import axios from 'axios'
import qs from 'qs'
import { configHandler, tokenHandler, errorHandler } from './handler.js'

// const baseURL = process.env.NODE_ENV === 'development' ? '/api/' : 'https://appinterface.xitohere.com';

// http 初始化配置
axios.defaults.timeout = 10000;
axios.defaults.responseType = "json";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api/' : 'https://appinterface.xitohere.com';
axios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.transformRequest = [
	function(data) {
		if(!(data instanceof FormData)){
			data = qs['stringify'](data);
		}
		return data;
	}
];

// http request 拦截器
axios.interceptors.request.use(
	config => {
        const { BASE_URL } = configHandler();
		const { isNeed_token, access_token } = tokenHandler(config.url);
        axios.defaults.baseURL = BASE_URL;
		if (isNeed_token) {
			// 已经携带的access_token不用默认的access_token
			if (config.data.access_token) {
				return config;
			}
			// 数据为FormData类型(上传文件)
			if (config.data instanceof FormData) {
				config.data.append('access_token', access_token);
			} else {
				config.data.access_token = access_token;
			}
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

//  http response 响应拦截器即异常处理
axios.interceptors.response.use(
	response => {
		return errorHandler(response);
	}, 
	err => {
		if (err && err.response) {
			switch (err.response.status) {
				case 400:
					console.log('%c 错误请求', 'color: red')
					break;
				case 401:
					console.log('%c 未授权，请重新登录', 'color: red')
					break;
				case 403:
					console.log('%c 拒绝访问', 'color: red')
					break;
				case 404:
					console.log('%c 请求错误,未找到该资源', 'color: red')
					break;
				case 405:
					console.log('%c 请求方法未允许', 'color: red')
					break;
				case 408:
					console.log('%c 请求超时', 'color: red')
					break;
				case 500:
					console.log('%c 服务器端出错', 'color: red')
					break;
				case 501:
					console.log('%c 网络未实现', 'color: red')
					break;
				case 502:
					console.log('%c 网络错误', 'color: red')
					break;
				case 503:
					console.log('%c 服务不可用', 'color: red')
					break;
				case 504:
					console.log('%c 网络超时', 'color: red')
					break;
				case 505:
					console.log('%c http版本不支持该请求', 'color: red')
					break;
				default:
					console.log('%c 连接错误', 'color: red', err.response)
			}
		} else {
			console.log('%c 连接到服务器失败', 'color: red', err.response)
		}
		return Promise.resolve(err.response);
	}
);

function get(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, data)
		.then(res => resolve(res))
		.catch(err => reject(err))
	});
}

function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
		.then(res => resolve(res))
		.catch(err => reject(err))
	});
}

function upload(url, data = {}, config = {}) {
	const formData = new FormData();
	Object.keys(data).forEach(key => formData.append(key, data[key]));
	// config可传入上传进度回调函数
	// { onUploadProgress: data => {}}
	// data => loaded已上传 total总的
	return new Promise((resolve, reject) => {
		axios.post(url, formData, config)
		.then(res => resolve(res))
		.catch(err => reject(err))
	});
}

export default { 
	get, 
	post, 
	upload
}